<template>
  <div>
    <div v-if="showBar && view === 'default'" style="height: 59px"></div>
    <div class="stickyHeaderBar w-full" v-if="showBar" :class="[saving, view]">
      <template v-if="saving === 'saving'">
        <div class="saveBar">
          <div class="saveBarBackground"></div>
          <div
            class="saveBarForeground"
            :style="{ width: (saveProgress / saveTotalItems) * 100 + '%' }"
          ></div>
        </div>
      </template>
      <div class="headerBarGrid">
        <div class="flex items-center justify-left flex-shrink-0 ml-3">
          <Logo :logoColor="view === 'save' ? 'light' : ''" />
        </div>
        <div>
          <div
            class="grid"
            style="max-width: 960px; margin: 0 auto"
            v-if="view === 'save'"
          >
            <div class="grid__cell col6-of-12">
              <span class="unsavedText" v-if="saving === 'idle'"
                >Unsaved changes</span
              >
              <span class="unsavedText" v-if="saving === 'saving'">
                {{ saveText }}
              </span>
              <span class="unsavedText" v-if="saving === 'done'">Saved</span>
              <span class="unsavedText" v-if="saving === 'error'"
                >Error saving</span
              >
            </div>
            <div class="grid__cell col6-of-12" style="text-align: right">
              <Button
                v-if="showDiscard"
                :bDisabled="saving === 'saving'"
                @button-click="$emit('discard')"
                bType="ghost"
                style="margin: 0 8px 0 auto"
                >{{ resetButtonText }}</Button
              >
              <Button
                :bDisabled="saving === 'saving'"
                @button-click="$emit('save')"
              >
                <template v-if="saving === 'saving'">
                  <svg
                    class="spinning"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.7344 1.51562C13.8164 1.43359 13.9258 1.40625 14.0625 1.46094C14.1992 1.51562 14.2812 1.625 14.2812 1.76172V5.67188C14.2812 5.78125 14.2266 5.86328 14.1719 5.91797C14.1172 5.97266 14.0352 6 13.9531 6H10.043C9.87891 6 9.79688 5.94531 9.74219 5.80859C9.6875 5.67188 9.6875 5.5625 9.79688 5.45312L11.3008 3.94922C10.7812 3.45703 10.207 3.07422 9.55078 2.80078C8.89453 2.52734 8.21094 2.39062 7.5 2.39062C6.57031 2.39062 5.69531 2.63672 4.90234 3.07422C4.08203 3.51172 3.45312 4.14062 2.96094 4.90625C2.46875 5.67188 2.19531 6.51953 2.14062 7.44922C2.14062 7.53125 2.08594 7.61328 2.03125 7.66797C1.97656 7.72266 1.89453 7.75 1.8125 7.75H1.04688C0.9375 7.75 0.855469 7.72266 0.800781 7.66797C0.746094 7.61328 0.71875 7.50391 0.71875 7.39453C0.773438 6.24609 1.12891 5.15234 1.73047 4.16797C2.33203 3.18359 3.15234 2.41797 4.19141 1.84375C5.20312 1.26953 6.29688 0.96875 7.5 0.96875C8.40234 0.96875 9.27734 1.16016 10.0977 1.48828C10.918 1.84375 11.6562 2.33594 12.2852 2.96484L13.7344 1.51562ZM13.9531 7.75C14.0352 7.75 14.1172 7.80469 14.1719 7.85938C14.2266 7.91406 14.2812 7.99609 14.2812 8.10547C14.1992 9.28125 13.8438 10.3477 13.2422 11.332C12.6406 12.3164 11.8203 13.1094 10.8086 13.6836C9.76953 14.2578 8.67578 14.5312 7.5 14.5312C6.57031 14.5312 5.69531 14.3672 4.875 14.0117C4.05469 13.6836 3.31641 13.1914 2.71484 12.5352L1.26562 13.9844C1.15625 14.0938 1.04688 14.0938 0.910156 14.0391C0.773438 13.9844 0.71875 13.9023 0.71875 13.7383V9.82812C0.71875 9.74609 0.746094 9.66406 0.800781 9.60938C0.855469 9.55469 0.9375 9.5 1.04688 9.5H4.95703C5.09375 9.5 5.20312 9.58203 5.25781 9.71875C5.3125 9.85547 5.28516 9.96484 5.20312 10.0469L3.69922 11.5508C4.19141 12.043 4.76562 12.4258 5.42188 12.6992C6.07812 12.9727 6.76172 13.1094 7.5 13.1094C8.42969 13.1094 9.27734 12.8906 10.0977 12.4531C10.8906 12.0156 11.5469 11.3867 12.0391 10.6211C12.5312 9.85547 12.8047 8.98047 12.8594 8.05078C12.8594 7.99609 12.8867 7.91406 12.9414 7.85938C12.9961 7.80469 13.0781 7.75 13.1875 7.75H13.9531Z"
                      fill="white"
                    />
                  </svg>
                </template>
                <template v-else>{{ saveButtonText }}</template>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/DesignSystem/Button';
import Logo from '@/components/DesignSystem/LogoFull';
import { mapState } from 'vuex';

const SAVE_MODE = {
  UPDATE: 'update',
  CREATE: 'create',
};

export default {
  name: 'HeaderBar',
  components: {
    Button,
    Logo,
  },
  props: {
    showBar: {
      type: Boolean,
      default: false,
    },
    showDiscard: {
      type: Boolean,
      default: true,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    view: {
      type: String,
      default: 'default',
      validate: view => ['default', 'save'].includes(view),
    },
    saveMode: {
      type: String,
      default: SAVE_MODE.UPDATE,
      validate: mode => Object.values(SAVE_MODE).includes(mode),
    },
  },
  computed: {
    ...mapState(['saving', 'saveProgress', 'saveTotalItems']),
    saveButtonText() {
      switch (this.saveMode) {
        case SAVE_MODE.CREATE:
          return 'Create and save';
        case SAVE_MODE.UPDATE:
        default:
          return 'Save';
      }
    },
    resetButtonText() {
      switch (this.saveMode) {
        case SAVE_MODE.CREATE:
        case SAVE_MODE.UPDATE:
        default:
          return 'Discard';
      }
    },
    saveText() {
      if (!this.showText) {
        return 'Saving changes';
      }
      let savePercent = (this.saveProgress / this.saveTotalItems) * 100;
      if (savePercent > 50 && savePercent <= 70) {
        return 'Saving changes - teleporting images to the server';
      } else if (savePercent > 70 && savePercent <= 85) {
        return 'Saving changes - powering up your partner profile';
      } else if (savePercent > 85 && savePercent < 100) {
        return 'Saving changes - finalizing updates';
      } else {
        return 'Saving changes';
      }
    },
  },
};
</script>

<style lang="scss">
/* Sticky Header */
.headerBarGrid {
  display: grid;
  grid-template-columns: 285px 1fr;
  height: 38px;
}
.stickyHeaderBar {
  position: fixed;
  top: 0;
  left: 0;
  height: 59px;
  padding: 11px 32px 11px 0;
  background: #fff;
  width: 100%;
  z-index: 99;
  border-bottom: 1px solid #e0e0e0;
  &.save {
    background: #3c4042;
  }
}
.unsavedText {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  line-height: 38px;
}
.stickyHeaderBar .button {
  font-weight: 500;
  padding: 8px 16px;
  min-width: 32px;
  font-size: 14px;
  line-height: 20px;
  &.button-type-primary {
    background: #7c5bc2;
    &:hover {
      background: #5b37a8;
    }
  }
  &.button-type-ghost {
    border: 1px solid #abb0b6;
    color: #fff;
    &:hover {
      color: #fff;
      background: #54575b;
      border: 1px solid #a0a0a0;
    }
  }
}

.saveBar {
  position: fixed;
  top: 0;
  left: 0;
  height: 4px;
  width: 100%;
  z-index: 3;
}
.saveBarBackground {
  height: 4px;
  position: fixed;
  z-index: 999;
  width: 100%;
}
.saveBarForeground {
  height: 4px;
  background-color: #a26cba;
  position: fixed;
  z-index: 1000;
  transition: width 0.2s;
}

.spinning {
  animation: rotation 2s infinite linear;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
